import React from 'react';
import './QuestionNavigator.css';

const QuestionNavigator = ({ 
  questions, 
  currentQuestion, 
  answers, 
  flaggedQuestions, 
  onQuestionSelect, 
  onToggleFlag,
  isVisible,
  onToggleVisibility 
}) => {
  const getQuestionStatus = (index) => {
    if (flaggedQuestions.has(index)) return 'flagged';
    if (answers[index]) return 'answered';
    if (index === currentQuestion) return 'current';
    return 'unanswered';
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'answered': return '✓';
      case 'flagged': return '🚩';
      case 'current': return '▶';
      default: return '';
    }
  };

  return (
    <>
      <button 
        className="navigator-toggle"
        onClick={onToggleVisibility}
        title="Toggle Question Navigator"
      >
        {isVisible ? '✕' : '☰'}
      </button>
      
      <div className={`question-navigator ${isVisible ? 'visible' : 'hidden'}`}>
        <div className="navigator-header">
          <h3>Questions</h3>
          <div className="navigator-legend">
            <div className="legend-item">
              <span className="legend-dot answered"></span>
              <span>Answered</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot flagged"></span>
              <span>Flagged</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot unanswered"></span>
              <span>Unanswered</span>
            </div>
          </div>
        </div>
        
        <div className="navigator-grid">
          {questions.map((_, index) => {
            const status = getQuestionStatus(index);
            return (
              <div key={index} className="question-nav-item">
                <button
                  className={`question-nav-btn ${status}`}
                  onClick={() => onQuestionSelect(index)}
                  title={`Question ${index + 1} - ${status}`}
                >
                  <span className="question-number">{index + 1}</span>
                  <span className="question-icon">{getStatusIcon(status)}</span>
                </button>
                <button
                  className={`flag-btn ${flaggedQuestions.has(index) ? 'flagged' : ''}`}
                  onClick={() => onToggleFlag(index)}
                  title={flaggedQuestions.has(index) ? 'Remove flag' : 'Flag for review'}
                >
                  🚩
                </button>
              </div>
            );
          })}
        </div>
        
        <div className="navigator-summary">
          <div className="summary-stats">
            <div>Answered: {Object.keys(answers).length}</div>
            <div>Flagged: {flaggedQuestions.size}</div>
            <div>Remaining: {questions.length - Object.keys(answers).length}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionNavigator;